import { ThemeProvider } from '@mui/material/styles'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { persistor, store } from 'app/store'
import esLocale from 'date-fns/locale/es'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import theme from 'theme/theme'

const Providers = (_props) => (
  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>{_props.children}</ThemeProvider>
      </PersistGate>
    </Provider>
  </LocalizationProvider>
)

export default Providers
